// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"3bf5e67b","453":"dcc3107a"}[chunkId] + ".chunk.js";
};